<template>
  <div class="live-container">
    <div class="common-title">
      <span>直播</span>
      <span>
        <router-link to="/live"> 更多<van-icon name="arrow" /> </router-link>
      </span>
    </div>
    <div v-if="onlines.length" class="live-item-container">
      <template v-for="online in onlines">
        <OnLive v-if="!online.time" :online="online" :key="online.event_info_id"></OnLive>
        <OnBoard v-else :item="online" :key="online.event_info_id"></OnBoard>
      </template>
    </div>
    <van-empty v-else description="暂无直播"></van-empty>
  </div>
</template>

<script>
import OnLive from '@/components/OnLive'
import OnBoard from '@/components/OnBoard'
export default {
  props: ['onlines'],
  components: {
    OnLive,
    OnBoard
  }
}
</script>

<style scoped lang="scss">
/* 直播 */
.live-container {
  .live-item-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
}
.common-title {
  padding: 16px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  span {
    &:nth-child(1) {
      font-size: 16px;
      color: rgba(48, 49, 51, 1);
      font-weight: 700;
    }
    &:nth-child(2) {
      color: #909399;
      font-size: 13px;
    }
  }
}
</style>
